/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createFormSubmissionDataSchema = z.object({
	answers: z.array(z.object({ questionId: z.string().uuid(), answer: z.array(z.string()).nullable().optional() })),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	poolConsent: z.boolean().nullable().optional(),
})

export type CreateFormSubmissionDataSchema = z.infer<typeof createFormSubmissionDataSchema>
